<script setup lang="ts">
import { useSubscription } from '@urql/vue'
import { useHealthCheck } from '~/composables/useHealthCheck'
import { useUserTracking } from '~/composables/useUserTracking'

// const commandPalette = ref()

// dealing with custom loading indication
const nuxtApp = useNuxtApp()
const store = useStore()

// Health check integration
const { isHealthy, checkHealth } = useHealthCheck(30000) // Check every 30 seconds

// Initialize user tracking
useUserTracking()

nuxtApp.hook('page:start', () => {
  store.loading = true
})
nuxtApp.hook('page:finish', () => {
  store.loading = false
})

const handleSubscription = (messages = [], response) => {
  notify({
    title: 'Job Notification',
    type: 'success',
    text: response?.messageAdded?.message?.message,
    duration: 5000, // these should be visible a bit longer
    data: response?.messageAdded?.message?.messageData
      ? JSON.parse(response?.messageAdded?.message?.messageData)
      : null,
  })
  return [response.messageAdded, ...messages]
}

const messageSubscription = useSubscription(
  {
    query: `
        subscription MessageAdded($userId: Int!) {
          messageAdded(userId: $userId) {
            message {
              id
              message
              messageData
              readAt
            }
          }
        }
      `,
    variables: {
      userId: store?.auth?.user?.id,
    },
  },
  handleSubscription,
)

const { data: dataSubscription, error: errorSubscription } = messageSubscription
</script>

<template>
  <div>
    <!-- System Error Overlay -->
    <SystemErrorOverlay :is-visible="!isHealthy" @retry="checkHealth" />

    <!-- A custom loading indicator -->
    <div
      v-if="store.loading"
      class="loading-wrapper z-[999] fixed top-0 right-0 flex items-center justify-center h-screen bg-black opacity-50"
    >
      <Spinner class="h-14 w-14 text-primary-600" />
    </div>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <Notify />
    <ConfirmDialog />
    <!-- <CommandPalette ref="commandPalette" /> -->
  </div>
</template>

<style lang="postcss">
.loading-wrapper {
  @apply w-full;

  @screen lg {
    width: calc(100% - 300px);
  }
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scroll {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

::-webkit-scrollbar {
  @apply w-2 h-2;
}

/* Track */
::-webkit-scrollbar-track {
  @apply bg-transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  @apply bg-gray-200 rounded-full;
}
</style>
